<template>
  <!-- cinthia@gmail.com -->
  <b-card>
    <h1>Formulario cyber-day</h1>
    <div v-if="!shipperId && !organizationId">
      si estas viendo esto, debes configurar el shipper o la organización
    </div>
    <b-form-select v-if="showSelectorShipper" v-model="shipperSelect" :options="arrayShippers" class="mb-2" />
    <div v-if="loadData && shipperId">
      <projection-selectors  :arrayData="arrayData" :form.sync="form" @disableSend="(data) => disable.projection = data" :sizeWeek.sync="sizeWeek"></projection-selectors>
      <check-options-projection :listOptions="listOptions" @disableSend="(data) => disable.options = data" :sizeWeek.sync="sizeWeek"></check-options-projection>
      <div class="d-flex justify-content-end">
        <!-- <b-button variant="danger" @click="deleteForm" v-if="formData.id" :disabled="!formData.id" class="mr-3 button--delete-form">Eliminar</b-button> -->
        <b-button variant="warning" @click="sendForm" :disabled="disable.projection || disable.options" class="button--send-form">Enviar</b-button>
      </div>
    </div>
  </b-card>
</template>
<script>
import projectionSelectors from './components/projectionSelectors.vue'
import checkOptionsProjection from './components/CheckOptionsProjections.vue'
import { mapGetters } from 'vuex'
import MaterialsService from '../materials/materials.service'
import Swal from 'sweetalert2'
import BaseServices from '@/store/services/index'

export default {
  components: {
    projectionSelectors,
    checkOptionsProjection
  },
  data() {
    return {
      materialsService: new MaterialsService(this),
      baseService: new BaseServices(this),
      arrayData: {
        warehouses: [],
        carriers: []
      },
      form: {},
      loadData: false,
      listOptions: [],
      disable: {
        projection: false,
        options: false
      },
      sizeWeek: 0,
      formData: {},
      arrayShippers: [],
      shipperSelect: null
    }
  },
  computed: {
    ...mapGetters({
      mySession: 'getSession'
    }),
    shipperId() {
      return this.mySession?.shipper?.id || this.shipperSelect
    },
    organizationId() {
      return this.mySession?.organization?.id || null
    },
    showSelectorShipper() {
      return ['marketplace', 'admin', 'super_admin'].includes(this.mySession?.role)
    }
  },
  watch: {
    mySession: {
      handler(newVal) {
        if (newVal) {
          if (this.showSelectorShipper) {
            this.getShippers()
          } else  {
            this.getData()
          }
         
        }
      },
      immediate: true
    },
    shipperSelect: {
      handler() {
        this.getData()
      },
      immediate: true
    }
  },
  methods: {
    deleteForm() {
      document.getElementById('loading-bg').style.display = 'block'
      const params = {
        shipper_id: this.shipperId,
        form_id: this.formData?.id
      }
      this.materialsService.callService('deleteFormCyberShipper', null, params)
        .then(response => {
          this.viewSuccessMessage('¡Formulario eliminado correctamente!', 'Hemos registrado tu respuesta')
          this.resetData()
        })
        .catch(error => {
          console.error(error)
          this.$alert(error)
        })
        .finally(() => {
          document.getElementById('loading-bg').style.display = 'none'
          this.getForm()
        })
    },
    getData() {
      this.loadData = false
      document.getElementById('loading-bg').style.display = 'block'
      if (!this.shipperId) return
      const params = {
        shipper_id: this.shipperId
      }
      const arrServices = [
        {
          name: 'getWarehousesPucon',
          queryParams: null,
          params: {
            ...params
          }
        },
        {
          name: 'getCarriersDistribution',
          queryParams: null,
          params: {
            ...params
          }
        }
      ]
      this.materialsService.callMultipleServices(arrServices, true)
        .then(response => {
          this.arrayData.warehouses = this.setData(response?.getWarehousesPucon?.data)
          this.arrayData.carriers = this.setData(response?.getCarriersDistribution?.data)
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
          this.loadData = true
          document.getElementById('loading-bg').style.display = 'none'
          this.getForm()
        })
    },
    getForm() {
      this.loadData = false
      document.getElementById('loading-bg').style.display = 'block'
      if (!this.shipperId) return
      const params = {
        shipper_id: this.shipperId
      }
      this.materialsService.callService('getFormCyberShipper', null, params)
        .then(response => {
          this.setDataGet(response?.data)
        })
        .catch(error => {
          console.error(error)
          this.resetData()
        })
        .finally(() => {
          this.loadData = true
          document.getElementById('loading-bg').style.display = 'none'
        })
    },
    setDataGet(data) {
      this.formData = {...data}
      this.listOptions = [...this.setDataListOptions(this.formData?.content)]
      this.form = this.setDataForm(this.formData?.content)
    },
    resetData() {
      this.formData = {}
      this.listOptions = [...this.setDataListOptions(null)]
      this.form = this.setDataForm(null)
    },
    setDataForm(data) {
      const extractedData = {}
      this.sizeWeek = 0
      for (const key in data) {
        if (key.startsWith('week_')) {
          const weekNumber = parseInt(key.split('_')[1])
          const index = weekNumber - 1
          const weekData = data[key]
          if (weekData.projection !== undefined) {
            extractedData[`projection_${index}`] = weekData.projection
          }
          if (weekData.courier !== undefined) {
            extractedData[`courier_${index}`] = weekData.courier ? this.arrayData.carriers.find(el => el.code === weekData.courier.toUpperCase()) : null
          }
          if (weekData.warehouse !== undefined) {
            extractedData[`warehouse_${index}`] = weekData.warehouse ? this.arrayData.warehouses.find(el => el.id === weekData.warehouse) : null
          }
          this.sizeWeek++
        }
      }
      return extractedData
    },
    setDataListOptions(data) {
      return [
        { name: 'Option_1', active: data?.option1, label: '¿Necesita segundo retiro?', required: true },
        { name: 'Option_2', active: data?.option2, label: '¿Necesita retiro el día sábado?', required: true },
        { name: 'Option_3', active: data?.option3, label: '¿Entrega carga paletizada?', required: true },
        { name: 'Option_4', active: data?.option4, label: '¿Manejan bultos big ticket?', required: true },
        { name: 'Option_5', active: data?.option5, label: '¿Necesitan inhouse? Si es así, indique la ventana horaria.', required: true, showTimer: true, timeStart: data?.schedule?.timeStart, timeEnd: data?.schedule?.timeEnd }
      ]
    },
    setData(data) {
      if (!data) return []
      return data.map(item => ({
        ...item,
        text: item.name
      }))
    },
    sendForm() {
      document.getElementById('loading-bg').style.display = 'block'
      const queryParams = {
        ...this.transformForm(this.form),
        ...this.transformListOptions(this.listOptions),
        contact: {
          name: this.mySession?.fullName ?? `${this.mySession?.first_name} ${this.mySession?.last_name}`,
          email: this.mySession?.email,
          phone: this.mySession?.phone
        }
      }
      const params = {
        shipper_id: this.shipperId
      }
      if (this.formData?.id) {
        params.form_id = this.formData?.id
      }
      const service = this.formData?.id ? 'updateFormCyberShipper' : 'createFormCyberShipper'
      this.materialsService.callService(service, queryParams, params)
        .then(response => {
          this.viewSuccessMessage('¡Formulario enviado con éxito!', 'Hemos registrado tu respuesta')
          this.resetData()
        })
        .catch(error => {
          console.error(error)
          this.$alert(error)
          this.resetData()
        })
        .finally(() => {
          this.loadData = true
          document.getElementById('loading-bg').style.display = 'none'
          this.getForm()
        })
    },
    transformForm(data) {
      const transformedData = {}
      for (const key in data) {
        const [type, indexStr] = key.split('_')
        const index = parseInt(indexStr)
        const weekKey = `week_${index + 1}` 
        if (!transformedData[weekKey]) {
          transformedData[weekKey] = {}
        }
        if (type === 'projection') {
          transformedData[weekKey].projection = parseInt(data[key])
        } else if (type === 'courier') {
          transformedData[weekKey].courier = data[key]?.code ? data[key].code.toLowerCase() : null
        } else if (type === 'warehouse') {
          transformedData[weekKey].warehouse = data[key]?.id ? data[key].id : null
        }
      }
      return transformedData
    },
    transformListOptions(data) {
      const transformedData = {
        schedule: {}
      }
      data.forEach(item => {
        const optionNumber = item.name.split('_')[1]
        if (optionNumber) {
          transformedData[`option${optionNumber}`] = item.active
        }
        if (item.showTimer) {
          transformedData.schedule.timeStart = !item.active ? null : item.timeStart
          transformedData.schedule.timeEnd = !item.active ? null : item.timeEnd
        }
      })
      return transformedData
    },
    viewSuccessMessage(textTitle, textBody) {
      Swal.fire({
        titleText: textTitle,
        html: textBody,
        background: '#E6F0E8',
        icon: 'success',
        position: 'bottom-start',
        showConfirmButton: false,
        showCloseButton: true,
        width: '750px',
        customClass: {
          popup: 'swal2-toast swal--cyber-form'
        },
        allowOutsideClick: false
      })
    },
    getShippers() {
      document.getElementById('loading-bg').style.display = 'block'
      const queryParams = {
      }
      const params = {
        organization_id: this.organizationId ?? 0
      }
      this.baseService.callService('getShipperOrganization', queryParams, params)
        .then(response => {
          this.arrayShippers = response.data.map(item => ({
            value: item.id,
            text: item.name1 || item.name2 || item.name
          }))
        })
        .catch(err => {
          console.error(err)
        })
        .finally(() => {
          document.getElementById('loading-bg').style.display = 'none'
        })
    }
  }

}
</script>
<style lang="scss">
  .button--send-form {
    background: linear-gradient(90.13deg, #F49243 0.15%, #F4BB43 99.93%);
  }
  .button--send-form,
  .button--delete-form {
    width: 151px;
    color: #FFFFFF;
    font-weight: 400;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0%;
  }
    .swal--cyber-form {
    .swal2-title,
    .swal2-html-container {
      font-family: Montserrat !important;
      font-weight: 300 !important;
      font-size: 14px !important;
      line-height: 100% !important;
      letter-spacing: 0 !important;
      color: #020202 !important;
    }
    .swal2-title {
      font-weight: 500 !important;
    }
  }
</style>